import { Button, Flex, Typography } from "antd"
import React, { type ReactNode } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

import { RoutesPaths } from "../../constants/routes.ts"
import { isAiToolAvailable } from "./ai-center-availability.ts"
import type { AiCenterTabKey } from "./ai-center-tabs.ts"

const { Title, Text } = Typography

/**
 * A tool's own pages (a 3D job, an estimate, the price book) answer a direct link
 * with "Coming soon" while the tool is not released, instead of loading it. The
 * page's code is untouched and loads again once the tool's status is live.
 */
export function AiToolAvailabilityGate({
  tool,
  children
}: {
  tool: AiCenterTabKey
  children: ReactNode
}) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  if (isAiToolAvailable(tool)) return <>{children}</>
  return (
    <Flex
      vertical
      align="center"
      justify="center"
      gap={12}
      className="px-6 py-20 text-center"
      data-testid="ai-tool-coming-soon"
    >
      <span className="rounded-full bg-[#F0EAFE] px-3 py-1 text-sm font-medium text-[#6941C6]">
        {t("aiCenter.comingSoon.badge")}
      </span>
      <Title level={4} style={{ margin: 0 }}>
        {t("aiCenter.comingSoon.pageTitle")}
      </Title>
      <Text type="secondary" style={{ maxWidth: 440 }}>
        {t("aiCenter.comingSoon.tooltip")}
      </Text>
      <Button type="primary" onClick={() => navigate(RoutesPaths.aiCenter)}>
        {t("aiCenter.comingSoon.backToAiCenter")}
      </Button>
    </Flex>
  )
}
